import * as React from 'react';
import FiltersPanel from '../filters/filters-panel';
import FiltersPanelAdv from '../filters/filters-panel-advanced';
import { getDentists, requestDentists, clearResults } from "../../redux/actions/find-a-dentist-api";
import { Dispatch, connect } from "react-redux";
import { FindAPDAppState } from "../../classes/redux-states";
import { FindAPDSettingsModel } from "../../redux/reducers/find-a-pd-settings";
import { setPage, updateNumberFilter, updateTextFilter } from "../../redux/actions/actions";
import { throttle, debounce } from 'lodash';

interface DispatchToProps {
    requestDentists: (page: number) => any;
    setPage: (page: number) => any;
    updateTextFilter: (filterName: string, filterValue: string) => any;
    updateNumberFilter: (filterName: string, filterValue: number) => any;
    clearResults: () => any;
}

export class FiltersContainer extends React.Component<DispatchToProps, any> {
    constructor(props: DispatchToProps) {
        super(props);
		this.toggleAdvancedFilters = this.toggleAdvancedFilters.bind(this);
		this.remeasurePanel = this.remeasurePanel.bind(this);

		this.getResults = this.getResults.bind(this);
		this.clearFilters = this.clearFilters.bind(this);
    }

	toggleAdvancedFilters(e) {
		let button = e.target,
			advancedFiltersPanel = document.querySelector('[data-advanced-filters]') as HTMLElement,
			panelItems = advancedFiltersPanel.querySelector('.find-a-pd-filters-panel') as HTMLElement;

        if (advancedFiltersPanel.getAttribute('aria-hidden') == 'true') {
			advancedFiltersPanel.setAttribute('aria-hidden', 'false');
            advancedFiltersPanel.style.height = panelItems.clientHeight + 'px';
            button.setAttribute('aria-expanded', 'true');
        } else {
            advancedFiltersPanel.setAttribute('aria-hidden', 'true');
            advancedFiltersPanel.style.height = '0';
            button.setAttribute('aria-expanded', 'false');
        }
    }

    toggleFiltersFromQueryString() {
        let button = document.getElementById('find-a-pd-filters-panel-adv') as HTMLElement,
            advancedFiltersPanel = document.querySelector('[data-advanced-filters]') as HTMLElement,
            panelItems = advancedFiltersPanel.querySelector('.find-a-pd-filters-panel') as HTMLElement;

        if (advancedFiltersPanel.getAttribute('aria-hidden') == 'true') {
            advancedFiltersPanel.setAttribute('aria-hidden', 'false');
            advancedFiltersPanel.style.height = panelItems.clientHeight + 'px';
            button.setAttribute('aria-expanded', 'true');
        } else {
            advancedFiltersPanel.setAttribute('aria-hidden', 'true');
            advancedFiltersPanel.style.height = '0';
            button.setAttribute('aria-expanded', 'false');
        }
    }


    getResults() {
        this.props.requestDentists(1);
        this.props.setPage(1);
    }

    getClearResults() {
        this.props.clearResults();
        this.props.setPage(1);
    }

    clearFilters() {
        var textBoxes = document.getElementsByClassName("textFilter");
        for (var i = 0; i < textBoxes.length; i++) {

            (textBoxes[i] as HTMLInputElement).value = "";
        }
        var zipCodeTextBox = document.getElementById("zipCode");
        (zipCodeTextBox as HTMLInputElement).value = "";
        var mileRadiusDropdown = document.getElementById("mileRadius") as HTMLSelectElement;
        mileRadiusDropdown.selectedIndex = 0;
        var pageSizeDropdown = document.getElementById("pageSize") as HTMLSelectElement;
        pageSizeDropdown.selectedIndex = 0;
        var countryDropdown = document.getElementById("country") as HTMLSelectElement;
        countryDropdown.selectedIndex = 0;
        var stateDropdown = document.getElementById("state") as HTMLSelectElement;
        stateDropdown.selectedIndex = 0;

        this.props.updateTextFilter("zipCode", "");
        this.props.updateNumberFilter("mileRadius", 5);
        this.props.updateNumberFilter("pageSize", 10);
        this.props.updateTextFilter("lastName", "");
        this.props.updateTextFilter("city", "");
        this.props.updateTextFilter("country", "");
        this.props.updateTextFilter("state", "");

        this.getClearResults();
	}

	remeasurePanel(panelContainer, panel) {
		panelContainer.style.height = panel.clientHeight + 'px';
	}

    getURLSearchParams(name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null) {
            return null;
        }
        else {
            return decodeURI(results[1]) || 0;
        }
    }

    getQueryStringParams() {
        var advancedOptions = this.getURLSearchParams("advancedOptions");
        if (advancedOptions == "true") {
            this.toggleFiltersFromQueryString();
            return;
        }

        var zipFromQueryString = this.getURLSearchParams("zipcode");
        var radiusFromQueryString = this.getURLSearchParams("mileRadius");
        var pageSizeFromQueryString = this.getURLSearchParams("pageSize");

        if (zipFromQueryString != null && zipFromQueryString != "")
        {
            this.props.updateTextFilter("zipCode", zipFromQueryString.toString());
            var zipCodeTextBox = document.getElementById("zipCode");
            (zipCodeTextBox as HTMLInputElement).value = zipFromQueryString.toString();

        }

        if (radiusFromQueryString != null && radiusFromQueryString != "")
        {
            var radius = parseInt(radiusFromQueryString.toString());
            var mileRadiusDropdown = document.getElementById("mileRadius") as HTMLSelectElement;
            for (var i = 0; i < mileRadiusDropdown.options.length; i++) {
                if (mileRadiusDropdown.options[i].text == radiusFromQueryString) {
                    mileRadiusDropdown.options[i].selected = true;
                }
            }
            this.props.updateNumberFilter("mileRadius", radius);
        }

        if (pageSizeFromQueryString != null && pageSizeFromQueryString != "")
        {
            var size = parseInt(pageSizeFromQueryString.toString());
            var pageSizeDropdown = document.getElementById("pageSize") as HTMLSelectElement;
            for (var i = 0; i < pageSizeDropdown.options.length; i++) {
                if (pageSizeDropdown.options[i].text == pageSizeFromQueryString) {
                    pageSizeDropdown.options[i].selected = true;
                }
            }
            this.props.updateNumberFilter("pageSize", size);
        }

        if (zipFromQueryString != null && radiusFromQueryString != null) {
            this.props.requestDentists(1);
        }

    }

    componentDidMount() {
        this.getQueryStringParams();
		let advancedFiltersPanel = document.querySelector('[data-advanced-filters]') as HTMLElement,
			panelItems = advancedFiltersPanel.querySelector('.find-a-pd-filters-panel') as HTMLElement;
        if (advancedFiltersPanel.getAttribute('aria-hidden') == 'true') {
            advancedFiltersPanel.style.height = '0';
        }
		window.addEventListener('resize', debounce(() => {
			if (advancedFiltersPanel) {
				this.remeasurePanel(advancedFiltersPanel, panelItems);
			}
		}, 50));
	}

	render() {

        return (
            <div className="find-a-pd-filters-container">
				<div className="find-a-pd-filters-panel-container" id="find-a-pd-filters-panel" aria-hidden="false">
					<FiltersPanel />
                </div>

                <button className="find-a-pd-filters-toggle" id="find-a-pd-filters-toggle" onClick={this.toggleAdvancedFilters} aria-expanded="false">
                    Advanced Options
				<svg className="svg-icon" aria-hidden="true" focusable="false">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron" />
                    </svg>
                </button>

                <div className="find-a-pd-filters-panel-adv-container" id="find-a-pd-filters-panel-adv" data-advanced-filters aria-hidden="true">
                    <FiltersPanelAdv />
                </div>
				<div className="find-a-pd-filters-controls">
					<button className="btn-primary btn-slim" onClick={this.getResults}>Search</button>
					<a className="find-a-pd-filters-controls-clear" onClick={this.clearFilters}>Clear Filters</a>
				</div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch: Dispatch<FindAPDAppState>): DispatchToProps {
    return {
        requestDentists: (page: number) => dispatch(getDentists(page)),
        setPage: (page: number) => dispatch(setPage(page)),
        updateNumberFilter: (filterName: string, filterValue: number) => dispatch(updateNumberFilter(filterName, filterValue)),
        updateTextFilter: (filterName: string, filterValue: string) => dispatch(updateTextFilter(filterName, filterValue)),
        clearResults: () => dispatch(clearResults())
    }
}

export default connect(null, mapDispatchToProps)(FiltersContainer);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/filters/filters-container.tsx